import React, { useState, useCallback } from 'react';
import './FaultSecondPage_Coral/FaultSecondPageCustom_Coral.css'
import DashboardMain_Coral from '../DashboardMain_Coral/DashboardMain_Coral';
import FaultSecondPageCharts_Coral from './FaultSecondPage_Coral/FaultSecondPageChartsLine_Coral';
import FaultSecondPageDataBars_Coral from './FaultSecondPage_Coral/FaultSecondPageDataBars_Coral';
import FaultSecondPageFilters_Coral from './FaultSecondPage_Coral/FaultSecondPageFilters_Coral';
import FaultSecondPageKpis_Coral from './FaultSecondPage_Coral/FaultSecondPageKpis_Coral';
import FaultSecondPageChartsBidir_Coral from './FaultSecondPage_Coral/FaultSecondPageChartsBidir_Coral';
import { INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitialstates_coral';

// import * as $ from 'jquery';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";

export default function Faultanalysis_Coral(props) {
    const [gloablfilter, setGloablfilter] = useState(INIT_FILTER_STATE);
    const [secondPageState, setSecondPageState] = useState({
        startDate: props.gloablfilter.startDate,
        endDate: props.gloablfilter.endDate,
        vin_num: props.gloablfilter.VIN_NUM.toString(),
    });

    const onreset = (data) => {
        setSecondPageState({
            startDate: props.gloablfilter.startDate,
            endDate: props.gloablfilter.endDate,
            vin_num: "",
        });
    }

    const filterSubmited = useCallback((data) => {
        setSecondPageState(data);
    }, []);

    return (
        <DashboardMain_Coral>
            <FaultSecondPageFilters_Coral onsubmit={filterSubmited} secondPageState={secondPageState} onreset={onreset} />
            <div className="container-fluid">
                <FaultSecondPageKpis_Coral gloablfilter={secondPageState} />
                <section className="graphs sec2Charts">
                    <FaultSecondPageDataBars_Coral gloablfilter={secondPageState} />
                    <div className="row mt-4 mb-3">
                        <FaultSecondPageCharts_Coral gloablfilter={secondPageState} />
                        <FaultSecondPageChartsBidir_Coral gloablfilter={secondPageState} />
                    </div>
                </section>
            </div>
        </DashboardMain_Coral>
    )
}
